'use client';

import type { ReactNode } from 'react';
import { createContext, useMemo, useState } from 'react';

export const LocalizedPageUrlContext = createContext<{
  url: string | undefined;
  setUrl: (url: string) => void;
}>({ url: undefined, setUrl: () => {} });

export const LocalizedPageUrlProvider = ({ children }: { children: ReactNode }) => {
  const [url, setUrl] = useState<string>();

  return (
    <LocalizedPageUrlContext.Provider value={useMemo(() => ({ url, setUrl }), [url, setUrl])}>
      {children}
    </LocalizedPageUrlContext.Provider>
  );
};
